// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-sm span{color:transparent}
`, "",{"version":3,"sources":["webpack://./src/components/progress/Progress.vue"],"names":[],"mappings":"AAEI,kBACI,iBAAkB","sourcesContent":["\n    /* Hide labels for small progress bars */\n    .progress-sm span {\n        color: transparent;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
